import { createComponent } from "@helpers/admin";
import PricingSectionComponent from "@template/blocks/PricingSection/component";

export const PricingSection = createComponent({
  label: "Pricing Section",
  component: PricingSectionComponent,
  fields: {
    heading: {
      label: "Heading",
      type: "textarea",
    },
    footer: {
      label: "Footer",
      type: "markdown",
    },
    countOptions: {
      label: "Count Options",
      type: "object",
      objectFields: {
        defaultValue: {
          label: "Default Count",
          type: "number",
          default: 1,
        },
        showInput: {
          label: "Show Number Input",
          type: "boolean",
          default: true,
        },
        showSlider: {
          label: "Show Slider",
          type: "boolean",
          default: true,
        },
      },
    },
    default: {
      label: "Use Default",
      type: "boolean",
      default: true,
    },
    hideStaticFooter: {
      label: "Hide 'Still Not Sure?' Line",
      type: "boolean",
      default: false,
    },
    corePlan: {
      label: "Core",
      type: "object",
      objectFields: {
        copy: {
          label: "Description",
          type: "markdown",
        },
        features: {
          label: "Main Feature",
          type: "array",
          arrayFields: {
            content: {
              label: "Content",
              type: "textarea",
            },
          },
        },
        list: {
          label: "Features",
          type: "object",
          objectFields: {
            ukFeatures: {
              label: "UK Features",
              type: "array",
              arrayFields: {
                iconName: {
                  label: "Icon",
                  type: "icon",
                },
                label: {
                  label: "Label",
                  type: "markdown",
                },
                tooltip: {
                  label: "Tooltip",
                  type: "textarea",
                },
              },
            },
            usdFeatures: {
              label: "USD Features",
              type: "array",
              arrayFields: {
                iconName: {
                  label: "Icon",
                  type: "icon",
                },
                label: {
                  label: "Features",
                  type: "markdown",
                },
                tooltip: {
                  label: "Tooltip",
                  type: "markdown",
                },
              },
            },
          },
        },
        featureFooter: {
          label: "Feature Footer",
          type: "object",
          objectFields: {
            content: { label: "Input", type: "textarea" },
            span: {
              label: "Span",
              type: "textarea",
            },
            link: {
              label: "Link",
              type: "object",
              objectFields: {
                label: {
                  label: "Label",
                  type: "textarea",
                  default: "Label",
                },
                href: {
                  label: "Link",
                  type: "textarea",
                  default: "/link",
                },
                title: {
                  label: "Title",
                  type: "textarea",
                },
              },
            },
          },
        },
      },
    },
    standardPlan: {
      label: "Standard",
      type: "object",
      objectFields: {
        copy: {
          label: "Description",
          type: "markdown",
        },
        features: {
          label: "Main Feature",
          type: "array",
          arrayFields: {
            content: {
              label: "Content",
              type: "textarea",
            },
          },
        },
        list: {
          label: "Features",
          type: "object",
          objectFields: {
            ukFeatures: {
              label: "UK Features",
              type: "array",
              arrayFields: {
                iconName: {
                  label: "Icon",
                  type: "icon",
                },
                label: {
                  label: "Features",
                  type: "markdown",
                },
                tooltip: {
                  label: "Tooltip",
                  type: "textarea",
                },
              },
            },
            usdFeatures: {
              label: "USD Features",
              type: "array",
              arrayFields: {
                iconName: {
                  label: "Icon",
                  type: "icon",
                },
                label: {
                  label: "Features",
                  type: "markdown",
                },
                tooltip: {
                  label: "Tooltip",
                  type: "markdown",
                },
              },
            },
          },
        },
        featureFooter: {
          label: "Feature Footer",
          type: "object",
          objectFields: {
            content: { label: "Input", type: "textarea" },
            span: {
              label: "Span",
              type: "textarea",
            },
            link: {
              label: "Link",
              type: "object",
              objectFields: {
                label: {
                  label: "Label",
                  type: "textarea",
                  default: "Label",
                },
                href: {
                  label: "Link",
                  type: "textarea",
                  default: "/link",
                },
                title: {
                  label: "Title",
                  type: "textarea",
                },
              },
            },
          },
        },
      },
    },
    premiumPlan: {
      label: "Premium",
      type: "object",
      objectFields: {
        copy: {
          label: "Description",
          type: "markdown",
        },
        features: {
          label: "Main Feature",
          type: "array",
          arrayFields: {
            content: {
              label: "Content",
              type: "textarea",
            },
          },
        },
        list: {
          label: "Features",
          type: "object",
          objectFields: {
            ukFeatures: {
              label: "UK Features",
              type: "array",
              arrayFields: {
                iconName: {
                  label: "Icon",
                  type: "icon",
                },
                label: {
                  label: "Features",
                  type: "markdown",
                },
                tooltip: {
                  label: "Tooltip",
                  type: "textarea",
                },
              },
            },
            usdFeatures: {
              label: "USD Features",
              type: "array",
              arrayFields: {
                iconName: {
                  label: "Icon",
                  type: "icon",
                },
                label: {
                  label: "Features",
                  type: "markdown",
                },
                tooltip: {
                  label: "Tooltip",
                  type: "markdown",
                },
              },
            },
          },
        },
        featureFooter: {
          label: "Feature Footer",
          type: "object",
          objectFields: {
            content: { label: "Input", type: "textarea" },
            span: {
              label: "Span",
              type: "textarea",
            },
            link: {
              label: "Link",
              type: "object",
              objectFields: {
                label: {
                  label: "Label",
                  type: "textarea",
                  default: "Label",
                },
                href: {
                  label: "Link",
                  type: "textarea",
                  default: "/link",
                },
                title: {
                  label: "Title",
                  type: "textarea",
                },
              },
            },
          },
        },
      },
    },
  },
});
